export class AssignableCompartmentListLoad {
  public static readonly type = '[AssignableCompartmentList] Load';
  constructor(public hubIds: number[]) {}
}

export class AssignableCompartmentListInitialState {
  public static readonly type = '[AssignableCompartmentList] Set Initial State';
}
